<template>
  <div style="height: 100%" v-if="result">
    <div class="d1">
      根据当前文本内容进行违规词检测，不可修改文本内容
    </div>
    <SearchInfo
      ref="searchinfo"
      :check="check"
      :percentage="percentage"
      :ptage="ptage"
      :contentCount="contentCount"
      :contentTime="contentTime"
      @CheckOver="CheckOver"
      CheckOver
      checkType="prohibited"
    ></SearchInfo>
  </div>
  <div v-else>
    <div class="resultDiv">
      <div style="width: 49%;display: inline-block">
        <div>
          <span style="font-size: 13px">广告词违规(16)</span>
        </div>
        <hr class="hr" />
      </div>
      <div style="width: 1%;display: inline-block">
        <hr id="hr1" class="hr1" />
      </div>
      <div style="width: 49%;display: inline-block">
        <div style="margin-left: 15px;">
          <span style="font-size: 13px;">敏感词违规(16)</span>
        </div>
        <hr class="hr" style="margin-left: 15px;" />
      </div>
      <div id="prohibList" class="listTable">
        <div>
          <table>
            <thead>
              <tr>
                <th>违规词</th>
                <th>类型</th>
              </tr>
            </thead>
            <tbody v-if="leftData">
              <tr
                @click="checkSingular(item.keyword)"
                v-for="(item, index) in filterType('AD')"
                :key="index + 'left'"
              >
                <td>
                  {{ item.keyword }}
                </td>
                <td
                  :title="item.issure == '确定' ? item.desc : item.issure"
                  :style="{
                    color: item.issure === '可疑' ? `rgb(238, 147, 11)` : `red`
                  }"
                >
                  {{ item.issure == "确定" ? item.desc : item.issure }}
                </td>
              </tr>
            </tbody>
          </table>
          <p v-if="!leftData">检查结果无广告词违规</p>
        </div>
        <div>
          <table style="padding-left: 20px;">
            <thead>
              <tr>
                <th>违规词</th>
                <th>类型</th>
              </tr>
            </thead>
            <tbody v-if="rightData">
              <tr
                @click="checkSingular(item.keyword)"
                v-for="(item, index) in filterType('Polity')"
                :key="index + 'right'"
              >
                <td>{{ item.keyword }}</td>
                <td
                  :title="item.issure == '确定' ? item.desc : item.issure"
                  :style="{
                    color: item.issure === '可疑' ? `rgb(238, 147, 11)` : `red`
                  }"
                >
                  {{ item.issure == "确定" ? item.desc : item.issure }}
                </td>
              </tr>
            </tbody>
          </table>
          <p v-if="!rightData">检查结果无敏感词违规</p>
        </div>
      </div>
    </div>
    <div class="center" style="position: fixed;bottom: 30px;right: 200px">
      <button class="btn3" @click="reset">重新检测</button>
    </div>
  </div>
</template>

<script>
import SearchInfo from "./SearchLoading";
import findWords from "../../assets/script/utils/findWords";
export default {
  name: "GetProhibited",
  components: {
    SearchInfo
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    contentCount: {
      get() {
        return this.$store.state.editorControl.contentCount;
      }
    }
  },
  watch: {
    contentHeight: {
      handler: function(val) {
        this.getLineHeight(val);
      }
    }
  },
  mounted() {
    this.getid = setInterval(() => {
      let getBox = document.getElementById("hr1");
      if (getBox) {
        clearInterval(this.getid);
        this.getLineHeight(this.contentHeight);
      }
    }, 500);
  },
  updated() {
    let getBox1 = document.getElementsByClassName("resultDiv")[0];
    if (getBox1) {
      let getBox2 = document.getElementById("hr1");
      if (getBox2) getBox2.style.height = getBox1.offsetHeight + "px";
      this.getLineHeight(this.contentHeight);
    }
  },
  data() {
    return {
      check: false,
      percentage: 0,
      ptage: null,
      result: true,
      contentTime: 20,
      tabHeight: 100,
      leftData: true,
      rightData: true,
      tableData: [],
      pNumber: 0
    };
  },
  methods: {
    reset() {
      this.result = true;
      this.$nextTick(() => {
        this.$refs.searchinfo.checkin();
      });
    },
    checkSingular(words) {
      findWords.closeAllHighlight();
      if (words.indexOf("+") !== -1) {
        words = words.split("+");
      }
      findWords.findkeywords(words, "getPro");
    },
    clear() {
      this.check = false;
      this.percentage = 0;
      this.ptage = null;
      this.result = true;
    },
    CheckOver(getMsg) {
      if (getMsg.ErrorCode > 0) {
        if (getMsg.ErrorCode === 200501) {
          this.insertConfig.showUpgrade(true, "获取更多使用次数");
        } else {
          this.$message({
            showClose: true,
            message: getMsg.ErrorMess,
            type: "error"
          });
        }
        return;
      }
      this.tableData = getMsg.Data;
      this.leftData = true;
      this.rightData = true;
      this.result = false;
      this.percentage = 0;
    },
    filterType(type) {
      let list = [];
      for (let item of this.tableData) {
        if (item.type === type) {
          list.push(item);
        }
      }
      if (type === "AD") {
        list.length > 0 ? (this.leftData = true) : (this.leftData = false);
      }
      if (type === "Polity") {
        list.length > 0 ? (this.rightData = true) : (this.rightData = false);
      }
      return list;
    },
    getLineHeight(windowheight) {
      let toolbar = document.querySelector(".el-header");

      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }

      let righttitle = document.querySelector(".tLeft");

      let righttitleHeight = 0;
      if (righttitle !== null && righttitle !== undefined) {
        righttitleHeight = righttitle.offsetHeight;
      }
      let editorStatusBarHeight = 100;
      let realHeight =
        windowheight -
        editorToolbarHeight -
        editorStatusBarHeight -
        righttitleHeight;

      let getBox = document.getElementById("hr1");
      if (getBox) getBox.style.height = realHeight + "px";

      let getListBox = document.getElementById("prohibList");
      this.tabHeight = realHeight - 30;
      if (getListBox) getListBox.style.height = this.tabHeight + "px";
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/mixin";
@import "../../assets/style/color";
* {
  font-size: 12px;
}
table {
  width: 97%;
  text-align: left;
  td,
  th {
    border: 0;
    display: inline-block;
    .ellipsis();
    &:nth-child(1) {
      width: 60%;
    }
    &:nth-child(2) {
      width: 40%;
    }
  }
  tbody {
    tr {
      line-height: 30px;
      &:hover {
        background-color: #e6e6e6;
      }
      cursor: pointer;
    }
    td {
      &:nth-child(1) {
        color: @theme-color;
      }
    }
  }
  tbody:before {
    content: "-";
    display: block;
    line-height: 1px;
    color: transparent;
  }
  th {
    font-weight: 500;
    color: #909399;
  }
}

.listTable {
  height: 300px;
  width: 100%;
  overflow: auto;
  overscroll-behavior-y: contain;
  div {
    width: 49%;
    display: inline-block;
    vertical-align: top;
    p {
      font-size: 12px;
      text-align: center;
      margin-top: 100px;
      color: #909399;
    }
  }
}
.d1 {
  line-height: 30px;
  margin-top: 5px;
  padding: 0 15px;
}
.hr {
  border: 1px solid #d3d7de;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  width: 90%;
  margin-top: 10px;
  margin-bottom: 5px;
}
.hr1 {
  position: absolute;
  display: inline-block;
  height: 360px;
  margin-top: -20px;
  margin-bottom: 10px;
  margin-left: -5px;
  border: 1px solid #d3d7de;
  border-left: 0;
  border-bottom: 0;
  border-top: 0;
}
.resultDiv {
  padding: 5px 10px;
  /*border: 1px solid #d3d7de;*/
  margin: 5px 5px;
  min-height: 150px;
}
.btn {
  background-color: #0f58f5;
  padding: 3px 9px;
  color: #fff;
  border: 1px solid #0f58f5;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 8px;
}
.btn3 {
  .btn;
  padding: 5px 15px;
  background-color: #167df3;
}
</style>
